import { render, staticRenderFns } from "./widget9.vue?vue&type=template&id=6f1ec9bf&scoped=true&"
import script from "./widget9.vue?vue&type=script&lang=js&"
export * from "./widget9.vue?vue&type=script&lang=js&"
import style0 from "./widget9.vue?vue&type=style&index=0&id=6f1ec9bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ec9bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
